import { type ApplicationRoute } from '@administration/shared/models/application-route';
import { NgClass } from '@angular/common';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'tess-navigation-popover',
  templateUrl: './navigation-popover.component.html',
  styleUrls: ['./navigation-popover.component.scss'],
  imports: [NgClass],
  host: {
    '[class]': 'position() + " shadow-sm text-white flex flex-col text-sm bg-menu-bg-1"',
  },
})
export class NavigationPopoverComponent {
  readonly item = input.required<ApplicationRoute>();
  readonly position = input<string | undefined>(undefined);

  readonly navigate = output<ApplicationRoute>();

  readonly itemClasses = 'cursor-pointer flex h-10 relative no-underline whitespace-nowrap';
}
